import standardApiRequestAction from 'my-core/standardApiRequestAction';

import types from '../constants/OnlineCourseActionTypes';
import API from '../core/api';

export function fetchOnlineCourseApi(onlineCourseId, params, fetchKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}`,
    requestKey: fetchKey,
    body: params,
  });
}

export function fetchOnlineCoursesApi(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/online_courses',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function fetchOnlineCourse(onlineCourseId) {
  return dispatch => {
    API.getJSON(`/online-courses/${onlineCourseId}`)
      .then(
        ({
          online_course: onlineCourse,
          online_course_feedback: onlineCourseFeedback,
          online_course_user: onlineCourseUser,
        }) => {
          dispatch({ type: types.FETCH_ONLINE_COURSE_SUCCESS, onlineCourse, onlineCourseUser, onlineCourseFeedback });
        },
      )
      .catch(error => {
        console.error(error);
        dispatch({ type: types.FETCH_ONLINE_COURSE_FAIL, onlineCourseId, error });
      });
  };
}

export function fetchOnlineCourseBooklet(onlineCourseId, params, fetchKey) {
  return dispatch => {
    API.getJSON(`/online-courses/${onlineCourseId}/booklet/${params.pathParts || ''}`)
      .then(
        ({ course_lessons: courseLessons, online_course: onlineCourse, quiz_questions: quizQuestions, quizzes }) => {
          dispatch({
            type: types.FETCH_ONLINE_COURSE_BOOKLET_SUCCESS,
            onlineCourse,
            quizzes,
            courseLessons,
            quizQuestions,
            fetchKey,
          });
        },
      )
      .catch(error => {
        console.error(error);
        dispatch({ type: types.FETCH_ONLINE_COURSE_BOOKLET_FAIL, onlineCourseId, error, fetchKey });
      });
  };
}

export function fetchOnlineCourseStats(onlineCourseId) {
  return dispatch => {
    API.getJSON(`/online-courses/${onlineCourseId}/stats`)
      .then(onlineCourse => {
        dispatch({ type: types.FETCH_ONLINE_COURSE_STATS_SUCCESS, onlineCourse });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.FETCH_ONLINE_COURSE_STATS_FAIL, error, onlineCourseId });
      });
  };
}

export function fetchOnlineCourseSubmissionResults(onlineCourseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/submission_results`,
    requestKey,
  });
}

export function fetchOnlineCourseTextbooks(fetchParams, requestKey) {
  return standardApiRequestAction({
    path: '/api/v1/online_courses/textbooks',
    body: fetchParams,
    requestKey,
  });
}

export function createOnlineCourse(params) {
  return dispatch => {
    API.postJSON('/online-courses', params)
      .then(
        ({ course_lessons: courseLessons, online_course: onlineCourse, quiz_questions: quizQuestions, quizzes }) => {
          dispatch({ type: types.CREATE_ONLINE_COURSE_SUCCESS, onlineCourse, quizzes, courseLessons, quizQuestions });
        },
      )
      .catch(error => {
        console.error(error);
        dispatch({ type: types.CREATE_ONLINE_COURSE_FAIL, error });
      });
  };
}

export function updateOnlineCourse(onlineCourseId, params) {
  return dispatch => {
    dispatch({ type: types.UPDATE_ONLINE_COURSE_FETCHING });
    API.putJSON(`/online-courses/${onlineCourseId}`, params)
      .then(
        ({ course_lessons: courseLessons, online_course: onlineCourse, quiz_questions: quizQuestions, quizzes }) => {
          dispatch({ type: types.UPDATE_ONLINE_COURSE_SUCCESS, onlineCourse, quizzes, courseLessons, quizQuestions });
        },
      )
      .catch(error => {
        console.error(error);
        dispatch({ type: types.UPDATE_ONLINE_COURSE_FAIL, onlineCourseId, error });
      });
  };
}

export function updateOnlineCourseApi(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${id}`,
    method: 'patch',
    body,
  });
}

export function resyncOnlineCourse(id, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${id}/resync`,
    method: 'put',
    body: params,
  });
}

export function importGoogleDocChapter(id, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${id}/import_google_doc_chapter`,
    method: 'post',
    body: params,
  });
}

export function fetchOnlineCourseSyncedFrom(id, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${id}/synced_from`,
    requestKey,
  });
}

export function publishOnlineCourse(onlineCourseId, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/publish`,
    method: 'patch',
    body: params,
  });
}

export function markPreparingOnlineCourse(onlineCourseId, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/mark_preparing`,
    method: 'patch',
    body: params,
  });
}

export function generateOnlineCourseBooklets(onlineCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/generate_booklets`,
    method: 'put',
  });
}

export function updateOnlineCourseQaChecklistItems(onlineCourseId, items) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/update_qa_checklist_items`,
    method: 'patch',
    body: { qa_checklist_items: items },
  });
}

export function createSyncedClassPass(ocId, body) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/synced_class_pass`,
    method: 'post',
    body,
  });
}

export function fetchTeacherTextbooks(fetchParams, requestKey) {
  return standardApiRequestAction({
    path: '/api/v1/online_courses/teacher_textbooks',
    body: fetchParams,
    requestKey,
  });
}

export function fetchInstructorOnlineCourses(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/online_courses/instructor_dashboard',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function fetchOnlineCourseUsageBreakdown(onlineCourseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/usage_breakdown`,
    requestKey,
  });
}

// FETCH ACTIVITIES

export function fetchOnlineCourseEditorActivities(params, fetchKey) {
  return dispatch => {
    API.getJSON('/online-courses/editor_activities', params)
      .then(({ course_lessons: courseLessons, quiz_questions: quizQuestions, quizzes }) => {
        dispatch({
          type: types.FETCH_ONLINE_COURSE_EDITOR_ACTIVITIES_SUCCESS,
          fetchKey,
          courseLessons,
          quizzes,
          quizQuestions,
        });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.FETCH_ONLINE_COURSE_EDITOR_ACTIVITIES_FAIL, error, fetchKey });
      });
  };
}

export function fetchOnlineCourseActivityApi(onlineCourseId, ocActivityId, fetchKey, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${onlineCourseId}/activity`,
    body: {
      activity_id: ocActivityId,
      ...params,
    },
    requestKey: fetchKey,
  });
}

// PRACTICE MODE

export function fetchOnlineCoursePracticeModeSubmissions(ocId, sectionId, fetchKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/practice_mode_submissions`,
    body: { section_id: sectionId },
    requestKey: fetchKey,
  });
}
export function fetchOnlineCoursePracticeModeQuestion(ocId, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/practice_mode_question`,
    body: params,
  });
}

// TEXTBOOK SECTIONS

export function fetchTextbookSection(ocId, sectId, params, fetchKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/textbook_sections/${sectId}`,
    body: params,
    requestKey: fetchKey,
  });
}

export function fetchTextbookSectionSyncedSections(ocId, sectId, params, fetchKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/textbook_sections/${sectId}/synced_sections`,
    body: params,
    requestKey: fetchKey,
  });
}
